import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import saladier500 from "@/assets/products/saladier-carre-500ml.jpg";
import saladier650 from "@/assets/products/saladier-carre-650ml.jpg";
import saladier1000 from "@/assets/products/saladier-carre-1000ml.jpg";
import saladier1300 from "@/assets/products/saladier-carre-1300ml.jpg";

const config: ProductPageConfig = {
  name: "Saladiers carrés kraft + couvercle rPET",
  breadcrumbName: "Saladiers carrés",
  subtitle: "Emballage alimentaire recyclable pour salades et pokés",
  features: ["Contact alimentaire", "Recyclable", "Couvercle rPET inclus", "Disponible en stock"],
  variants: [
    { ref: "SAL500C", capacity: "500 ml", dimensions: "112 x 112 mm", height: "55 mm", material: "Carton kraft + couvercle rPET", packaging: "Carton de 200 (8 x 25)", palette: "30 cartons", image: saladier500 },
    { ref: "SAL650C", capacity: "650 ml", dimensions: "112 x 112 mm", height: "70 mm", material: "Carton kraft + couvercle rPET", packaging: "Carton de 200 (8 x 25)", palette: "30 cartons", image: saladier650 },
    { ref: "SAL1000C", capacity: "1000 ml", dimensions: "138 x 138 mm", height: "75 mm", material: "Carton kraft + couvercle rPET", packaging: "Carton de 200 (8 x 25)", palette: "15 cartons", image: saladier1000 },
    { ref: "SAL1300C", capacity: "1300 ml", dimensions: "138 x 138 mm", height: "95 mm", material: "Carton kraft + couvercle rPET", packaging: "Carton de 200 (8 x 25)", palette: "15 cartons", image: saladier1300 },
  ],
};

const SaladiersCarres = () => <ProductPageLayout config={config} />;
export default SaladiersCarres;
